/**
 * Admin Layout Component
 * Section 6.1 - Main layout wrapper with sidebar
 */

import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

function AdminLayout({ onLogout }) {
  return (
    <div className="admin-layout">
      <AdminSidebar onLogout={onLogout} />
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
